import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { useGetUser } from '@/hooks/requests/useUser';
import { Card } from '@mui/material';
import ProfileEditAdvisorForm from './ProfileEditAdvisorForm';
import { useGetTeammateListForSelection } from '@/hooks/requests/useTeammates';
import { TeammateRole } from '@/types/teammates';

export default function ProfileEditAdvisor() {
  const { user } = useGetUser();
  const companyId = user?.teammateInfo?.company.uuid;
  const { teammatesList, isTeammatesListPending } =
    useGetTeammateListForSelection({
      company_id: companyId,
      roles: [TeammateRole.ADMIN, TeammateRole.ADVISOR],
    });

  if (!user || !user.teammateInfo || !teammatesList || isTeammatesListPending) {
    return (
      <DefaultLayout header="Profile">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout header="Profile">
      <ProfileEditAdvisorForm user={user} teammatesList={teammatesList} />
    </DefaultLayout>
  );
}
